import { type MutationUpdaterFn } from "@apollo/client";
import { LensOperations } from "../../lens-details/api/cache";
import { type LensConnectionsFragment } from "../fragments/lensConnections.gql-generated";
import { lensConnectionsFragment } from "../fragments/lensConnections";
import { type LensDetailsConnectionFragment } from "../fragments/lensDetailsConnectionFragment.gql-generated";
import { type LensCompoundId } from "../../../../gql-generated/types";

type DataProxy = Parameters<MutationUpdaterFn>[0];

export const LensCache = {
    createLensWithConnectionsId(lensRef?: LensCompoundId | null) {
        if (lensRef === undefined || lensRef === null) {
            return "";
        }
        const key = {
            lens: {
                compoundId: {
                    id: lensRef.id,
                    reference: lensRef.reference,
                },
            },
        };
        return `LensWithConnections:${JSON.stringify(key)}`;
    },

    addNewConnection(cache: DataProxy, createConnection: LensDetailsConnectionFragment) {
        const { lens: lensFromConnection } = createConnection;

        let lens: LensConnectionsFragment | null = null;
        try {
            lens = cache.readFragment<LensConnectionsFragment>({
                id: LensCache.createLensWithConnectionsId(lensFromConnection?.compoundId),
                fragment: lensConnectionsFragment,
                fragmentName: "LensConnections",
            });
        } catch (error) {
            console.info(error);
        }

        if (lens) {
            cache.writeFragment({
                id: LensCache.createLensWithConnectionsId(lensFromConnection?.compoundId),
                fragment: lensConnectionsFragment,
                data: LensOperations.addConnection(lens, createConnection),
                fragmentName: "LensConnections",
            });
        }
    },

    removeConnection(cache: DataProxy, compoundId: LensCompoundId, connectionId: string) {
        let fragmentData: LensConnectionsFragment | null = null;

        try {
            fragmentData = cache.readFragment<LensConnectionsFragment>({
                id: LensCache.createLensWithConnectionsId(compoundId),
                fragment: lensConnectionsFragment,
                fragmentName: "LensConnections",
            });
        } catch (error) {
            console.info(error);
        }

        if (fragmentData) {
            cache.writeFragment({
                id: LensCache.createLensWithConnectionsId(compoundId),
                fragment: lensConnectionsFragment,
                data: LensOperations.removeConnection(fragmentData, connectionId),
                fragmentName: "LensConnections",
            });
        }
    },
};
